import React from 'react';
import { Grid } from '@mui/material';
import RecentList from './RecentList';

const HomeRecent = ({ stats, loading }) => {
  return (
    <>
      <Grid size={{ xs: 12, md: 6 }}>
        <RecentList
          title="Recent Library Documents"
          items={stats.recentDocuments}
          type="document"
          loading={loading}
          link="https://trccompanies.sharepoint.com/sites/CS-P3/Port-of-Oakland/Environmental%20Document%20Bibliography/Forms/Test.aspx"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <RecentList
          title="Recent Database Records"
          items={stats.recentRecords}
          type="record"
          loading={loading}
          link="https://trccompanies.sharepoint.com/sites/CS-P3/Port-of-Oakland/Lists/DEV%20Environmental%20Document%20Database/AllItems.aspx?viewpath=%2Fsites%2FCS%2DP3%2FPort%2Dof%2DOakland%2FLists%2FEMDS%20Library%2FAllItems%2Easpx"
        />
      </Grid>
    </>
  );
};

export default HomeRecent; 